import React from 'react';
import { Box, BottomNavigation, BottomNavigationAction } from '@mui/material';
import { Link } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';
import DashboardMobileTabBadgeCounter from './DashboardMobileTabBadgeCounter';

const RenderTabWithBadge = ({ label, url, icon, badgeCounter, testId }) => (
  <BottomNavigationAction
    sx={{
      textAlign: 'center',

      '&.Mui-selected': {
        transition: 'background-color 0.2s ease, color 0.2s ease',
        color: 'secondary.main',

        '& svg': {
          color: 'secondary.main',
        },
      },

      '& .MuiBottomNavigationAction-label': {
        fontWeight: 500,
        fontSize: Capacitor.isNativePlatform() ? '0.85rem' : '0.75rem',
        whiteSpace: 'nowrap',
        '&.Mui-selected': {
          fontSize: Capacitor.isNativePlatform() ? '0.85rem' : '0.75rem',
        },
      },
    }}
    component={Link}
    to={url}
    icon={
      <DashboardMobileTabBadgeCounter
        sx={{
          '& .MuiBadge-badge': {
            top: 10,
            right: -5,
          },
        }}
        badgeContent={badgeCounter}
        color="primary"
      >
        {icon}
      </DashboardMobileTabBadgeCounter>
    }
    label={label}
    key={testId}
    data-testid={testId}
    data-introid={testId}
  />
);

const MobileWrapper = ({
  activeTab,
  breadcrumb,
  bottomTabs,
  pageContent,
  containerId = 'dashboard-mobile-div',
  bottomBarId = 'mobile-app-bar',
}) => (
  <Box
    data-testid={containerId}
    sx={{
      position: 'absolute',
      height: 'calc(100% - calc(58px * 2) - var(--safe-area-inset-bottom))', // page height - (navbar + bottombar) - iphone spacing
      width: '100%',
      margin: '-8px',
      display: 'flex',
      flexDirection: 'column',
    }}
  >
    {breadcrumb}

    <Box sx={{ display: 'flex', flex: 1, overflow: 'hidden' }}>{pageContent}</Box>

    {bottomTabs.length > 0 && (
      <Box
        sx={[
          {
            position: 'fixed',
            backgroundColor: '#fafafa',
            zIndex: 2,
            bottom: 0,
            width: '100%',
            display: 'flex',
            overflow: 'auto',
            borderTop: '1px solid #d4d4d4',
          },
          Capacitor.isNativePlatform() && { paddingBottom: 'calc(var(--safe-area-inset-bottom) - 0.75rem )' },
          Capacitor.getPlatform() === 'android' && { paddingBottom: 'calc(var(--safe-area-inset-bottom))' },
        ]}
        data-introid={containerId}
      >
        <BottomNavigation
          sx={{ backgroundColor: '#fafafa', zIndex: 1, width: '100%', margin: '0 auto' }}
          value={activeTab}
          showLabels
          id={bottomBarId}
        >
          {bottomTabs.map(RenderTabWithBadge)}
        </BottomNavigation>
      </Box>
    )}
  </Box>
);

export default MobileWrapper;
